module.exports = __webpack_public_path__ + "static/media/ellipsis-v-alt.bba12494.svg";